document.addEventListener('DOMContentLoaded', function () {
    // Target "notification-bar__message" class with counter
    const messageElement = document.querySelector('.notification-bar__message');

    if (!messageElement) return; // Exit if the element doesn't exist

    // Sale end date and time (Melbourne timezone)
    const saleEndDate = new Date("2025-01-01T23:59:00+11:00"); // NSW is GMT+11 during daylight savings

    // Create a span element for the countdown
    const countdownSpan = document.createElement('span');
    countdownSpan.style.marginLeft = "8px"; // Optional styling
    countdownSpan.style.color = "#ffffff";
    messageElement.appendChild(countdownSpan);

    function updateCountdown() {
        const now = new Date();
        const timeRemaining = saleEndDate - now;

        if (timeRemaining <= 0) {
            countdownSpan.textContent = "";
            clearInterval(timerInterval); // Stop updating the timer
            return;
        }

        // Calculate days, hours, minutes, and seconds
        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        // Update the countdown text
        countdownSpan.textContent = ` ${days}d ${hours}h ${minutes}m ${seconds}s`;
    }

    // Start the countdown
    updateCountdown(); // Initial call
    const timerInterval = setInterval(updateCountdown, 1000); // Update every second
});
